import { render, staticRenderFns } from "./ColorPoly.vue?vue&type=template&id=015bdf92&"
import script from "./ColorPoly.vue?vue&type=script&lang=js&"
export * from "./ColorPoly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports